import { defineAsyncComponent } from 'vue';
import {
  SOCIAL_LISTENING_REPORT_SECTIONS,
  SOCIAL_LISTENING_ROUTE_NAMES,
} from '@/app/socialListening/constants';
import TopicComparison from '@/app/socialListening/pages/TopicComparison.vue';

const App = () => import('@/app/socialListening/App.vue');
const NoOrgAccess = () => import('@/app/socialListening/pages/NoOrgAccess.vue');
const NoUserAccess = () => import('@/app/socialListening/pages/NoUserAccess.vue');
const Trends = defineAsyncComponent(() => import('@/app/socialListening/pages/Trends.vue'));
const Overview = defineAsyncComponent(() => import('@/app/socialListening/pages/Overview.vue'));
const Topics = () => import('@/app/socialListening/pages/Topic.vue');

const PAGE_LEVEL_TOP = 'Social Listening';

export default {
  name: 'socialListening',
  path: 'listening',
  component: App,
  meta: {
    requiresAuth: true,
    analytics: `${PAGE_LEVEL_TOP} - Root`,
  },
  children: [
    {
      name: SOCIAL_LISTENING_ROUTE_NAMES.OVERVIEW,
      path: 'overview',
      component: Overview,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview`,
      },
    },
    {
      name: SOCIAL_LISTENING_ROUTE_NAMES.TRENDS,
      path: 'trends',
      component: Trends,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Trends`,
        section: SOCIAL_LISTENING_REPORT_SECTIONS.SOCIAL_TRENDS,
      },
      children: [
        {
          name: SOCIAL_LISTENING_ROUTE_NAMES.TRENDS_REPORT,
          path: 'report',
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Trends - Report`,
            section: SOCIAL_LISTENING_REPORT_SECTIONS.SOCIAL_TRENDS,
            report: true,
          },
        },
      ],
    },
    {
      name: SOCIAL_LISTENING_ROUTE_NAMES.NO_ORG_ACCESS,
      path: 'upgrade',
      component: NoOrgAccess,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Organization No Access`,
        noAccessRoute: true,
        hideSecondaryNav: true,
      },
    },
    {
      name: SOCIAL_LISTENING_ROUTE_NAMES.NO_USER_ACCESS,
      path: 'no-access',
      component: NoUserAccess,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - User No Access`,
        noAccessRoute: true,
        hideSecondaryNav: true,
      },
    },
    {
      name: SOCIAL_LISTENING_ROUTE_NAMES.NO_TOPIC,
      path: 'topics',
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Topics Root`,
      },
    },
    {
      name: SOCIAL_LISTENING_ROUTE_NAMES.TOPICS,
      path: 'topics/:id',
      component: Topics,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Topics`,
        isTopicRoute: true,
        section: SOCIAL_LISTENING_REPORT_SECTIONS.TOPIC,
      },
    },
    {
      name: SOCIAL_LISTENING_ROUTE_NAMES.TOPICS_REPORT,
      path: 'topics/:id/report',
      component: Topics,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Topics - Report`,
        isTopicRoute: true,
        section: SOCIAL_LISTENING_REPORT_SECTIONS.TOPIC,
        report: true,
      },
    },
    {
      name: SOCIAL_LISTENING_ROUTE_NAMES.NO_TOPIC_COMPARISONS,
      path: 'comparisons',
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Comparisons Root`,
      },
    },
    {
      name: SOCIAL_LISTENING_ROUTE_NAMES.TOPIC_COMPARISONS,
      path: 'comparisons/:id',
      component: TopicComparison,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Comparisons`,
      },
    },
  ],
};
